import express, { Router } from 'express';

import * as partnerNetworkValidation from '@/modules/partnerNetwork/partnerNetwork.validation';
import * as partnerNetworkController from '@/modules/partnerNetwork/partnerNetwork.controller';

import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';

import validate from '@/shared/utils/middlewares/validate.middleware';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';
import { AuditMode } from '@/shared/constants/enum.constant';
import { setAuditFields } from '@/shared/middleware/setAuditFields';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PARTNER_NETWORK, ACTIONS.READ),
    validate(partnerNetworkValidation.getPartnerNetwork),
    partnerNetworkController.getPartnerNetwork,
  )
  .post(
    userAuthAndCheckPermissions(),
    validate(partnerNetworkValidation.connectPartnerNetwork()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    partnerNetworkController.connectPartnerNetwork,
  );

router
  .route('/:id')
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.PARTNER_NETWORK, ACTIONS.UPDATE),
    validate(partnerNetworkValidation.connectPartnerNetwork()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    partnerNetworkController.updatePartnerNetworkRequest,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.PARTNER_NETWORK, ACTIONS.UPDATE),
    validate(partnerNetworkValidation.deletePartnerNetworkById),
    partnerNetworkController.deletePartnerNetworkById,
  );

export default router;
